import { QUERY_BUILDER_V0 } from 'bones/utils/queryBuilder/migrate/v0/constants';
import { v1 } from 'bones/utils/queryBuilder/migrate/v1';
import { QUERY_BUILDER_V1 } from 'bones/utils/queryBuilder/migrate/v1/constants';
import { v2 } from 'bones/utils/queryBuilder/migrate/v2';
import { QUERY_BUILDER_V2 } from 'bones/utils/queryBuilder/migrate/v2/constants';
import { v3 } from 'bones/utils/queryBuilder/migrate/v3';
import { QUERY_BUILDER_V3 } from 'bones/utils/queryBuilder/migrate/v3/constants';
import { v4 } from 'bones/utils/queryBuilder/migrate/v4';
import { QUERY_BUILDER_V4 } from 'bones/utils/queryBuilder/migrate/v4/constants';
import { v5 } from 'bones/utils/queryBuilder/migrate/v5';
import { QUERY_BUILDER_V5 } from 'bones/utils/queryBuilder/migrate/v5/constants';
import { AllQueryBuilder, QueryBuilder } from 'bones/utils/queryBuilder/types';

export const migrate = (advancedQuery: AllQueryBuilder): QueryBuilder => {
  switch (advancedQuery.version) {
    case QUERY_BUILDER_V0: {
      return migrate({
        version: QUERY_BUILDER_V1,
        data: v1(advancedQuery.data),
      });
    }
    case QUERY_BUILDER_V1: {
      return migrate({
        version: QUERY_BUILDER_V2,
        data: v2(advancedQuery.data),
      });
    }
    case QUERY_BUILDER_V2: {
      return migrate({
        version: QUERY_BUILDER_V3,
        data: v3(advancedQuery.data),
      });
    }
    case QUERY_BUILDER_V3: {
      return migrate({
        version: QUERY_BUILDER_V4,
        data: v4(advancedQuery.data),
      });
    }
    case QUERY_BUILDER_V4: {
      return migrate({
        version: QUERY_BUILDER_V5,
        data: v5(advancedQuery.data),
      });
    }
    case QUERY_BUILDER_V5: {
      return advancedQuery;
    }
    default: {
      throw Error('invalid version');
    }
  }
};
